import { SvgIcon } from '@mui/material';

export function Unchecked() {
  return (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="11" strokeWidth="2" />
    </SvgIcon>
  );
}
